import { Link } from "@mui/material";
import { useTeamConfig } from "../hooks/useTeamConfig";

export function DefaultCheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={"https://www.attend.tech/terms-of-use"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={"https://www.attend.tech/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function DefaultRegistrationTerms() {
  const { teamName } = useTeamConfig();
  return (
    <>
      By creating an account, you agree to receive account-related notifications
      and marketing communications from the {teamName}, and you confirm that you
      have read and agree to the platform&apos;s{" "}
      <Link
        href={"https://www.attend.tech/terms-of-use"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={"https://www.attend.tech/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
